import React, { Fragment } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import _ from 'lodash';
import {
  Button,  
  DialogContent,  
  Divider,
  Grid,
  IconButton,
} from "@material-ui/core";
import styled from 'styled-components';
import { withStyles, withTheme } from "@material-ui/core/styles";
import FileUpload from "components/Files/Upload";
import { addFeatureImageToDeal } from "store/state/deal";
import {Formik} from 'formik';

import DealProperties from "components/DealPipelineForm/Sections/DealProperties/DealProperties";
import { updatePipelineDeal } from "store/state/deal";
import ViewAndEditAssetDetails from "./ViewAndEditAssetDetails";
import PipelineActiveDealDetailsHeader from './PipelineActiveDealDetailsHeader';
import Styles from "components/Global/Fields/styles";
import SimpleConfirmDialog from "components/Global/ConfirmationDialogs/SimpleConfirmDialog"
import placeholder from "lib/images/featured-image-tmp.png";
import { DEAD, SOLD } from "constants/status";
import SimpleInfoDialog from "components/Global/ConfirmationDialogs/SimpleInfoDialog"

const styles = () => ({});

const StyledDiv = styled.div`
  margin: 5px 90px 0 10px;
`;

const StyledHeading = styled.div`
font-size: 20px;
`;

const StyledEditButton = styled(Button)`
  && {
    color: white;
    background-color: rgba(0, 157, 223, 1);
    height: 22px;
    top: -26px;
    left: 92px;
  }
`;

const StyledCancelButton = styled(Button)`
  && {
    color: white;
    background-color: rgba(0, 157, 223, 1);
    height: 22px;
    top: -26px;
    left: 110px;
  }
`;

const VerticalSpace = styled.div`
  width:100%;
  height:64px;
`

class PipelineDealViewAndEdit extends React.Component {

  constructor(props) {
    super(props);
    this.formik = React.createRef();
  }

  state = {
    isNewDeal: true,
    isInitialized: false,
    isEditing: false,
    isEditImage: false,
    modalOpen: false,

    addEditAlertIsOpen: false,   
    isAlert: true,    
    confirmDialogOpen: false,
    popupOpen:false,
    validationModalOpen: false,
  };

  
  renderFeatureLockedModel = () => {
    return(
    <SimpleInfoDialog 
            title="Feature Locked"
            message="This feature is only available for Professional, Secondary Sponsor and Enterprise subscriptions."
            modalOpen={this.state.popupOpen}
            handleClose={this.closePopup}
            handleAccept={this.closePopup}
            secondaryContent={
              <p>
                    If you would to schedule a demo to view these features, contact <a href ="mailto:sales@loanboss.com">sales@loanboss.com</a>. <br/> <br/>
                    Please contact your LoanBoss Administrator to upgrade or if you believe you are seeing this message in error: <a href="mailto:support@loanboss.com">support@loanboss.com</a>.
                  </p>
            }
            />
      )
  }

  
  isProTier = () => {
    if(this.props.authentication){
      return this.props.authentication.companyLevel==="Professional"
      || this.props.authentication.companyLevel==="Enterprise"
      || this.props.authentication.companyLevel==="Secondary Sponsor"
  }else{
    return false;
  }
  }

  openPopup = () =>{
    this.setState({popupOpen: true});
  }

  closePopup = () =>{
    this.setState({popupOpen: false});
  }

  componentDidMount() {
    let shouldEditDeal = window.localStorage.getItem("shouldEditDeal");
    if(shouldEditDeal){
      window.localStorage.removeItem("shouldEditDeal");
      this.setState({
        isEditing:true
      })
    }
    this.setState({
      deal: {
        properties: []
      }
    });
  };

  allowUploadNewImage = () => {
    this.setState({
      isEditImage: true,
    })
  };

  handleUpload = files => {
    const { deal } = this.props;
    this.props.addFeatureImageToDeal("deal", deal.id, files[0], `/deals/${deal.id}/coverphoto/`, () => {this.props.refreshDeal()});
    this.setState({
      isEditImage: false,
    })
  };

  editDeal = () => {
    this.setState({
      isEditing: true,
    })
  };

  saveEditedDeal = () => {
    if(!this.formik.current.state.values.targetedClosing){
      this.setState({validationModalOpen:true})
      this.formik.current.setError({targetedClosing:"required"})
      return;
    }
    this.formik.current.submitForm()
  }

  cancelEditDeal = () => {
    this.setState({
      modalOpen: true,
    });
  }

  cancelEditImage = () => {
    this.setState({
      isEditImage: false,
    })
  }

  handleClose = () => {
    this.setState({
      modalOpen: false,
    });
  };

  revertForm = () => {
    this.formik.current.resetForm();
    this.setState({
      modalOpen: false,
      isEditing: false,
    });
  }

  addAlert = () => { this.setState({addEditAlertIsOpen: true, isAlert: true});};
  setReminder = () => {this.setState({addEditAlertIsOpen: true, isAlert: false});};
  handleCancelAlertReminder = () => {this.setState({addEditAlertIsOpen: false,confirmDialogOpen: false});};  
  handleSaveAlertReminder = () => {this.setState({ addEditAlertIsOpen: false,confirmDialogOpen: false});};
  shouldIncludeAlertButtons(){
    const {deal} = this.props;
    return deal && deal.dealStatusId !== DEAD && deal.dealStatusId !== SOLD;
  }

  render() {
    const {
      isNewDeal,
      isInitialized,
      isEditing,
      modalOpen,
    } = this.state;

    const {
        theme,
        deal,
        dealId,
        onAddProperty, 
        onEditProperty,
        onDeleteProperty,
        classes,
        openNotes,
        openAttachments,
        guestPermissions
    } = this.props;
    // deal must not be an empty object
    if (_.isEmpty(deal)) return null;    
    let initializedDeal = {
      teamMember: "",
      ...deal
    }
    return (
      <Fragment>
        
        <SimpleInfoDialog 
          title = {"Unable To Save Deal"}
          message = {"Targeted Closing Date is required"}
          handleClose = {()=>this.setState({validationModalOpen:false})}
          handleAccept = {()=>this.setState({validationModalOpen:false})}
          modalOpen = {this.state.validationModalOpen}
        />
        <SimpleConfirmDialog 
            title="Confirm Cancel"
            message="You are about to cancel all of your changes. Are you sure you want to do this?"
            noText="NO"
            yesText="YES, CANCEL"
            modalOpen={modalOpen}
            handleNo={this.handleClose}
            handleYes={this.revertForm}/>
        
        <PipelineActiveDealDetailsHeader
          dealId={dealId}
          includeAlertButtons={this.shouldIncludeAlertButtons()}
          isEditing={isEditing}
          editDeal={this.editDeal}
          cancel={this.cancelEditDeal}
          save={this.saveEditedDeal}
          openNotes={openNotes}
          openAttachments={openAttachments}
          showNotesAttachmentsLinks={true}
          authentication={this.props.authentication}
          //Alert / Reminder Props
          parent={this}
          addEditAlertIsOpen={this.state.addEditAlertIsOpen}
          isAlert={this.state.isAlert}
          addAlert={this.addAlert}
          setReminder={this.setReminder}
          handleCancel={this.handleCancelAlertReminder}
          handleSave={this.handleSaveAlertReminder}
          guestPermissions={guestPermissions}
          guestStore={this.props.guestStore}
        />
          
        <Grid
          container
          spacing={8}
          alignItems="flex-start"
          justify="flex-start"
          direction="row"
        >
          <Grid item lg={3} md={4} sm={4}>
           {this.state.isEditImage ? 
            <StyledDiv>
              <FileUpload onDrop={this.handleUpload} />
              <StyledCancelButton
                variant="extendedFab"
                onClick={this.cancelEditImage}
              >CANCEL</StyledCancelButton>
            </StyledDiv> :
            <StyledDiv>
                <img
                  src={!deal.imageMedium ? placeholder : deal.imageMedium}
                  alt="Featured"
                  width="280"
                />
                {this.state.isEditing ? 
                <StyledEditButton
                  variant="extendedFab"
                  onClick={this.allowUploadNewImage}
                >EDIT IMAGE</StyledEditButton> :
                null
                }
            </StyledDiv>}          
            
          </Grid>

          <Grid item lg={4} md={6} sm={12}>
          <Formik
          enableReinitialize
          ref={this.formik}
          initialValues={initializedDeal}
          validateOnSubmit
          validateOnChange
          validate={values => {
              const {funds} = values;
              let error = {};
              const selectedFundIds = funds.map(x => x.id);
              let dupedFundIds = _.filter(selectedFundIds, (val, i, iteratee) => _.includes(iteratee, val, i + 1));
              for(let i = 0; i < funds.length; i++){
                let curFund = funds[i];
                if(!curFund.id)
                  error[`funds[${i}].id`] = 'Required'
                else if(dupedFundIds.indexOf(curFund.id) > -1)
                  error[`funds[${i}].id`] = 'Duplicate group selected'
                else
                  delete error[`funds[${i}].id`]                

                if(!curFund.fundDealBridge.allocationPercent)
                  error[`funds[${i}].fundDealBridge.allocationPercent`] = 'Required'
                else if(curFund.fundDealBridge.allocationPercent < 0.01 || curFund.fundDealBridge.allocationPercent > 100)
                  error[`funds[${i}].fundDealBridge.allocationPercent`] = 'Must be between 0.01% and 100%'
                else
                  delete error[`funds[${i}].fundDealBridge.allocationPercent`]
              }
              if(!values.targetedClosing) error.targetedClosing = "Required"
              return error;
          }}
          onSubmit={(values, actions) => {
            const modifiedValues = _.cloneDeep(values);            
            modifiedValues.dealStatusId = modifiedValues.dealStatusId ? modifiedValues.dealStatusId : null;
            modifiedValues.stageId = modifiedValues.stageId ? modifiedValues.stageId : null;
            modifiedValues.projectTypeId = modifiedValues.projectTypeId ? modifiedValues.projectTypeId : null;            
            for(let i =0; i < modifiedValues.funds.length;i++){
              modifiedValues.funds[i].fundDealBridge.allocationPercent /= 100;
            }
            delete modifiedValues.properties; // need to delete properties before updating deal since it won't have the updated information.            
            this.props.updatePipelineDeal(modifiedValues,{
              dealId: dealId,
              subKey: dealId
            });
            this.setState({
              isEditing: false,
            })
            actions.setSubmitting(false)
          }}

          render={({values, errors, status, touched, isSubmitting, handleChange, handleBlur, setFieldValue, handleSubmit}) => (
            <Styles theme={theme}>
              <div>
              <ViewAndEditAssetDetails
                values={values}
                dealId={dealId}
                isNewDeal={isNewDeal}
                isEditing={isEditing}                
                isInitialized={isInitialized}
                handleChange={handleChange}
                setFieldValue={setFieldValue}
                guestPermissions={guestPermissions}
              />
              </div>
            </Styles>
          )}/>
          </Grid>

          <Grid item lg={3} md={4} sm={12}>
            <StyledHeading>Properties</StyledHeading>
            <Grid item xs ={12}>
              <Divider />
            </Grid>
            <DealProperties 
                onAddProperty={onAddProperty}
                onEditProperty={onEditProperty}
                onDeleteProperty={onDeleteProperty}
                isViewOnlyMode={!isEditing}
                properties={deal.properties}
                guestPermissions={guestPermissions}
                />
          </Grid>

        </Grid>
        <VerticalSpace />
        {this.renderFeatureLockedModel()}
      </Fragment>
    );
  }
}

const mapStateToProps = ({ authentication, guest }) => ({
    authentication,
    guestStore: guest,
});

export default compose(
  connect(
    mapStateToProps,
    {
      updatePipelineDeal,
      addFeatureImageToDeal,      
    }
  ),
  withStyles(styles),
  withTheme()
)(PipelineDealViewAndEdit);